import { render, staticRenderFns } from "./AddCategoryEquipmentPage.vue?vue&type=template&id=32cd67a2"
import script from "./AddCategoryEquipmentPage.vue?vue&type=script&lang=js"
export * from "./AddCategoryEquipmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports